import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import axiosApiInstance from '../../utils/apiClient';
import { messageFrontEnd } from '../../utils/mensajeErrorCliente';
import { endpoints } from './../config';

const initialState = {
  isSuccess: 'idle',
  message: '',
  isLoading: false,
  mensajeros: [],
  estados: [],
  controlMensajeria: [],
  controlMensajeriaCount: 0,
};

export const fetchControlMensajeria = createAsyncThunk('controlMensajeria/fetchControlMensajeria', async (filter) => {
  const resultado = await axiosApiInstance.post(endpoints.controlMensajeria.getList, filter);
  return resultado.data;
});

export const fetchControlMensajeriaCount = createAsyncThunk('controlMensajeria/fetchControlMensajeriaCount', async (filter) => {
  const resultado = await axiosApiInstance.post(endpoints.controlMensajeria.getCountList, filter);
  return resultado.data;
});

export const fetchInsertOrUpdate = createAsyncThunk('controlMensajeria/fetchInsertOrUpdate', async (data) => {
  const resultado = await axiosApiInstance.post(endpoints.controlMensajeria.insertOrUpdate, data);
  return resultado.data;
});

export const fetchGetEstados = createAsyncThunk('controlMensajeria/fetchGetEstados', async () => {
  const resultado = await axiosApiInstance.get(endpoints.controlMensajeria.getEstados);
  return resultado.data;
});

export const fetchGetMensajeros = createAsyncThunk('controlMensajeria/fetchGetMensajeros', async () => {
  const resultado = await axiosApiInstance.get(endpoints.controlMensajeria.getMensajeros);
  return resultado.data;
});

export const fetchGetControlMensajeriaReport = createAsyncThunk('controlMensajeria/fetchGetControlMensajeriaReport', async (filtro) => {
  const result = await axiosApiInstance({
    url: endpoints.controlMensajeria.getReport,
    method: 'POST',
    responseType: 'blob',
    data: filtro,
  }).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute(
      'download',
      `Reporte de Control de Mensajería (${moment(filtro.fechaInicio).format('DD-MM-yyyy')} - ${moment(filtro.fechaFin).format('DD-MM-yyyy')}).xls`
    ); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });

  return result;
});

export const fetchCambiarSuccess = createAsyncThunk('login/fetchCambiarSuccess', async () => {
  return null;
});

const ControlMensajeriaSlice = createSlice({
  name: 'controlMensajeria',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(fetchCambiarSuccess.fulfilled, (state) => {
        state.isSuccess = 'idle';
      })
      .addCase(fetchControlMensajeria.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
        state.isSuccess = 'idle';
      })
      .addCase(fetchControlMensajeria.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.controlMensajeria = action.payload.data;
        } else {
          state.controlMensajeria = [];
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
      })
      .addCase(fetchControlMensajeria.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        state.controlMensajeria = [];
        console.error(action.error.message);
      })
      .addCase(fetchControlMensajeriaCount.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
        state.isSuccess = 'idle';
      })
      .addCase(fetchControlMensajeriaCount.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.controlMensajeriaCount = action.payload.data;
        } else {
          state.controlMensajeriaCount = 0;
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
      })
      .addCase(fetchControlMensajeriaCount.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        state.controlMensajeriaCount = 0;
        console.error(action.error.message);
      })
      .addCase(fetchInsertOrUpdate.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
        state.isSuccess = 'idle';
      })
      .addCase(fetchInsertOrUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
        } else {
          state.isSuccess = 'error';
        }

        state.message = action.payload.message;
      })
      .addCase(fetchInsertOrUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        console.error(action.error.message);
      })
      .addCase(fetchGetEstados.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
        state.isSuccess = 'idle';
      })
      .addCase(fetchGetEstados.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.estados = action.payload.data;
        } else {
          state.estados = [];
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
      })
      .addCase(fetchGetEstados.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        state.estados = [];
        console.error(action.error.message);
      })
      .addCase(fetchGetMensajeros.pending, (state, action) => {
        state.isLoading = true;
        state.message = '';
        state.isSuccess = 'idle';
      })
      .addCase(fetchGetMensajeros.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.isSuccess = 'success';
          state.mensajeros = action.payload.data;
        } else {
          state.mensajeros = [];
          state.isSuccess = 'error';
        }
        state.message = action.payload.message;
      })
      .addCase(fetchGetMensajeros.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        state.mensajeros = [];
        console.error(action.error.message);
      })
      .addCase(fetchGetControlMensajeriaReport.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = 'idle';
        state.message = '';
      })
      .addCase(fetchGetControlMensajeriaReport.fulfilled, (state, action) => {
        state.isSuccess = 'success';
        state.message = 'El reporte fue generado.';
        state.isLoading = false;
      })
      .addCase(fetchGetControlMensajeriaReport.rejected, (state, action) => {
        state.isSuccess = 'error';
        state.message = messageFrontEnd();
        state.isLoading = false;
        console.error(action.error.message);
      });
  },
});

export const selectControlMensajeria = (state) => state.controlMensajeria.controlMensajeria;
export const selectControlMensajeriaCount = (state) => state.controlMensajeria.controlMensajeriaCount;
export const selectEstados = (state) => state.controlMensajeria.estados;
export const selectMensajeros = (state) => state.controlMensajeria.mensajeros;
export const selectIsLoading = (state) => state.controlMensajeria.isLoading;
export const selectIsSuccess = (state) => state.controlMensajeria.isSuccess;
export const selectMessage = (state) => state.controlMensajeria.message;

export default ControlMensajeriaSlice.reducer;
